export default __webpack_public_path__ + "static/media/call-to-action-index.e48b7aeb.png";